// extracted by mini-css-extract-plugin
module.exports = {"container":"DetailList_container__BqFtZ","heading":"DetailList_heading___La_T","text":"DetailList_text___e0IY"};